export default {

  required: v => {
    return (v && v.toString().length > 0) || 'Por favor, preencha este campo'
  },

  requiredPrice: v => {
    return (v && v.toString().length > 0 && v.toString() != '0,00') || 'Por favor, preencha este campo'
  }

}
